import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BankMutationKeys } from '../../../keys'
import { deleteBankAccount } from '../../services'

interface UseMutationDeleteBankAccountProps {
	id: string
}

export default function useMutationDeleteBankAccount(
	props?: UseBaseMutationOptions<void, UseMutationDeleteBankAccountProps>,
) {
	return useMutation({
		mutationKey: [BankMutationKeys.DeleteBankAccount],
		mutationFn: ({ id }) => deleteBankAccount(id),
		...props,
	})
}
